module.exports = __webpack_public_path__ + "assets/img/jxxwq.41181bbd.png";